import { render } from "./ForeignObject.vue?vue&type=template&id=10bb456d"
import script from "./ForeignObject.vue?vue&type=script&lang=js"
export * from "./ForeignObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__